import { Route } from '@angular/router';
import { authGuard, publicOnlyGuard } from '@shared-data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'login',
    canActivate: [publicOnlyGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },

  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout-wrapper.component').then(
        (m) => m.LayoutWrapperComponent,
      ),
    children: [
      {
        path: '',
        redirectTo: 'cashier',
        pathMatch: 'full',
      },
      {
        path: 'cashier',
        loadComponent: () =>
          import('./features/cashier/cashier.component').then(
            (m) => m.CashierComponent,
          ),
      },
      {
        path: 'giros',
        loadComponent: () =>
          import('./features/giros/giros.component').then(
            (m) => m.GirosComponent,
          ),
      },
      {
        path: 'courier',
        loadComponent: () =>
          import('./features/courier/courier.component').then(
            (m) => m.CourierComponent,
          ),
      },
      {
        path: 'traslados',
        loadComponent: () =>
          import('./features/traslados/traslados.component').then(
            (m) => m.TrasladosComponent,
          ),
      },
      {
        path: 'fondeos',
        loadComponent: () =>
          import('./features/fondeos/fondeos.component').then(
            (m) => m.FondeosComponent,
          ),
      },
      {
        path: 'extracciones',
        loadComponent: () =>
          import('./features/extracciones/extracciones.component').then(
            (m) => m.ExtraccionesComponent,
          ),
      },
      {
        path: 'soporte',
        loadComponent: () =>
          import('./features/soporte/soporte.component').then(
            (m) => m.SoporteComponent,
          ),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./features/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
      },
      {
        path: 'chat/:id',
        data: { kind: 'staff' },
        loadComponent: () =>
          import('@shared-data-access/services/inbox/chat-thread.component').then(
            (m) => m.ChatThreadComponent,
          ),
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'login',
  },
];
